import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { IPump } from 'src/app/storage/interfaces/pump.interface';
import { Pump } from 'src/app/storage/models/pump.model';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class PumpsService {

  pumps$: BehaviorSubject<Pump[]> = new BehaviorSubject(null);

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService
  ) { }

  async getPumps(marketname: string, missionId: string): Promise<Pump[] | null> {
    const translations = await this.translateService.get('PUMPS').toPromise();

    const response = await this.apiService.get(
      `${URL}pumps/market/${marketname}/${missionId}`,
      translations['LABEL']
    );

    return response ?
          response.pumps.map((pump: IPump) => new Pump(pump)) :
          null;
  }
}
